import { string, shape, number, bool, arrayOf } from 'prop-types';

export const accountTypes = shape({
  id: number,
  client_number: number,
  address: string,
  holder_name: string,
  rate: string,
  status: bool,
  latitude: number,
  longitude: number,
  adherence_to_automatic_debit: string,
  adherence_to_digital_bill: string,
  balance: number,
  chart_type: string,
  digital_bill_adherence_form_id: number,
  form_responses_count: number,
  push_notifications_enabled: bool,
  automatic_debit_adherence_form_id: number,
  new_notifications: bool,
  related_accounts: bool,
  user_adherence_to_digital_bill: bool,
  claims_enabled: bool,
  automatic_debit_enabled: bool,
  digital_bill_enabled: bool,
  cancel_service_enabled: bool,
  new_service_enable: string,
  city: string,
  district: string,
  is_prepaid: string,
  depends_on_electricity: string,
  can_send_meter_reads: string,
  can_request_social_rate: string,
  alias: string,
  relationship: string,
  profile: string,
  meter_type: string,
  meter_number: string,
  meter_prepaid_number: string,
  meter_numerators_quantity: string,
  can_delegate: string,
  can_download_bill: string,
  can_view_bill_history: string,
  can_manage_payments: string,
  can_view_consumptions: string,
  suggest_digital_bill_adherence: string,
  contact_emails: string,
  accountUpdated: bool
});

export const accountAlertTypes = shape({
  id: number,
  title: string,
  message: string,
  category: string
});

export const accountsPropTypes = shape({
  id: string,
  client_number: string,
  address: string
});

export const questionsPropTypes = arrayOf(
  shape({
    field_options: arrayOf(
      shape({
        correct: bool.isRequired,
        id: number.isRequired,
        name: string.isRequired,
        order: number.isRequired
      })
    ),
    type: string.isRequired,
    id: number.isRequired,
    order: number.isRequired,
    title: string.isRequired
  })
);
